import styled from '@emotion/styled';
import React from 'react';

type Props = {
  size: number;
};

const IconDiscord = ({ size }: Props) => {
  return (
    <Svg
      width={size}
      height={size}
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='18' cy='18' r='18' fill='#F0F0F0' />
      <path
        d='M24.9419 13.0887C23.6473 12.5801 22.263 12.2105 20.8157 12C20.638 12.2698 20.4304 12.6328 20.2872 12.9215C18.7487 12.7272 17.2245 12.7272 15.7143 12.9215C15.5712 12.6328 15.3588 12.2698 15.1795 12C13.7307 12.2105 12.3448 12.5815 11.0502 13.0914C8.43887 16.4049 7.73099 19.636 8.08493 22.8212C9.81688 23.9072 11.4953 24.567 13.1455 24.9987C13.5529 24.5278 13.9163 24.0273 14.2293 23.4998C13.6331 23.3096 13.0621 23.0748 12.5226 22.8023C12.6657 22.7133 12.8057 22.6202 12.941 22.5244C16.2318 23.8168 19.8074 23.8168 23.0589 22.5244C23.1958 22.6202 23.3358 22.7133 23.4774 22.8023C22.9362 23.0762 22.3637 23.3109 21.7675 23.5012C22.0805 24.0273 22.4423 24.5292 22.8513 25C24.503 24.5683 26.183 23.9086 27.915 22.8212C28.3303 19.1287 27.2056 15.9273 24.9419 13.0887ZM14.6776 20.8623C13.6898 20.8623 12.8796 20.0879 12.8796 19.1449C12.8796 18.2019 13.6725 17.4261 14.6776 17.4261C15.6829 17.4261 16.493 18.2005 16.4757 19.1449C16.4772 20.0879 15.6829 20.8623 14.6776 20.8623ZM21.3223 20.8623C20.3344 20.8623 19.5243 20.0879 19.5243 19.1449C19.5243 18.2019 20.3171 17.4261 21.3223 17.4261C22.3275 17.4261 23.1376 18.2005 23.1203 19.1449C23.1203 20.0879 22.3275 20.8623 21.3223 20.8623Z'
        fill='#4D5CED'
      />
    </Svg>
  );
};

const Svg = styled.svg`
  :hover {
    circle {
      fill: #f5c1c1;
    }
  }
`;

export default IconDiscord;
